import {RSAA} from "redux-api-middleware";

export const SUBLEAGUE_MESSAGES_SET = 'SUBLEAGUE_MESSAGES_SET';
export const SUBLEAGUE_MESSAGE_SENT = 'SUBLEAGUE_MESSAGE_SENT';
export const SUBLEAGUE_MESSAGES_HIDE = 'SUBLEAGUE_MESSAGES_HIDE';

const messageSentAction = (message) => ({
    type: SUBLEAGUE_MESSAGE_SENT,
    payload: message
});

const messagesSetAction = (messages, subleagueId) => ({
    type: SUBLEAGUE_MESSAGES_SET,
    payload: {
        subleagueId,
        messages
    }
});

export const fetchMessages = (subleagueId) => (dispatch, getState) => {

    if (!getState().user.loggedIn) {
        return dispatch(chatHideAction(subleagueId));
    }

    dispatch({
        [RSAA]: {
            endpoint: `/api/v1/my/prizeSubleagueChat/${subleagueId}`,
            method: 'GET',
            credentials: 'same-origin',
            types: [
                'REQUEST',
                {
                    type: 'SUCCESS',
                    payload: (action, state, res) => (
                        res.json().then(
                            json => {
                                if (json.error) {
                                    return dispatch(chatHideAction(subleagueId));
                                }

                                dispatch(messagesSetAction(json.data, subleagueId));
                            }
                        )
                    )
                },
                chatHideAction(subleagueId)
            ]
        }
    });
};

export const sendMessage = (subleagueId, message) => (dispatch) => {

    dispatch({
        [RSAA]: {
            endpoint: `/api/v1/my/prizeSubleagueChat/${subleagueId}`,
            method: 'PUT',
            credentials: 'same-origin',
            body: JSON.stringify({message}),
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            types: [
                'REQUEST',
                {
                    type: 'SUCCESS',
                    payload: (action, state, res) => (
                        res.json().then(
                            json => {
                                dispatch(messageSentAction(json.data));
                            }
                        )
                    )
                },
                chatHideAction(subleagueId)
            ]
        }
    });
};

const chatHideAction = (subleagueId) => ({
    type: SUBLEAGUE_MESSAGES_HIDE,
    payload: subleagueId
});